import styled from '@emotion/styled';
import { UserInteraction } from '@naf/user-interaction';
import { spacing } from '@naf/theme';

export const StyledUserInteraction = styled(UserInteraction)`
  margin-top: ${spacing.space32};
  margin-bottom: ${spacing.space32};
`;
